import { Component, OnInit, Input, OnChanges, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { UserStorageService } from 'src/app/services/user-storage-service/user-storage.service';
import { SnackBarService } from 'src/app/components/shared-components/snack-bar/snack-bar.service';
import { Router } from '@angular/router';
import * as moment from 'moment/moment';
import { Schedule } from 'src/app/models/schedule-models/schedule.model';
import { NgxMaterialTimepickerTheme } from 'ngx-material-timepicker';
import { TimePickerCustomTheme } from 'src/app/config';
import { DesksTurnsService } from 'src/app/services/turns-services/desks-turns-service/desks-turns.service';
import { ActivatedRoute } from '@angular/router';
import { UpdateScheduleConfirmationDialogComponent } from '../../shared-components/update-schedule-confirmation-dialog/update-schedule-confirmation-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { TIMEZONES } from 'src/assets/timezones/timezones';

@Component({
  selector: 'app-turns-desk-schedule-info-card',
  templateUrl: './turns-desk-schedule-info-card.component.html',
  styleUrls: ['./turns-desk-schedule-info-card.component.scss']
})
export class TurnsDeskScheduleInfoCardComponent implements OnInit, OnChanges, OnDestroy {

  @Input() schedule: Schedule;
  timezones;
  TimePickerCustomTheme: NgxMaterialTimepickerTheme;
  updateDeskScheduleSubscription: Subscription;
  showingAfternoon: boolean;

  basicDataForm = new FormGroup({
    name: new FormControl('', Validators.required),
    openingService: new FormControl(true),
    dateFrom: new FormControl(null, Validators.required),
    dateTo: new FormControl(null, Validators.required),
    morningFrom: new FormControl(null),
    morningTo: new FormControl(null),
    afternoonFrom: new FormControl(null),
    afternoonTo: new FormControl(null),
    monday: new FormControl(true),
    tuesday: new FormControl(true),
    wednesday: new FormControl(true),
    thursday: new FormControl(true),
    friday: new FormControl(true),
    saturday: new FormControl(true),
    sunday: new FormControl(true),
    allday: new FormControl(true),
    timeZone: new FormControl('Europe/Madrid')
  });

  constructor(private desksTurnsService: DesksTurnsService,
    public dialog: MatDialog,
    private userStorageService: UserStorageService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private snackbarService: SnackBarService) {
      this.TimePickerCustomTheme = TimePickerCustomTheme;
      this.timezones = TIMEZONES;
    }

  ngOnInit() { }

  ngOnChanges() {
    if (this.schedule) {
      this.resetForm();
    }
  }

  public resetForm() {
    if ((moment(this.schedule.OpenTimeMorning).utc().format('HH:mm') === '00:01') && (moment(this.schedule.CloseTimeMorning).utc().format('HH:mm') === '23:59')) {
      this.basicDataForm.patchValue({
        allday: true
      });
    } else {
      this.basicDataForm.patchValue({
        allday: false
      });
    }
    this.basicDataForm.patchValue({
      name: this.schedule.CommentNote,
      openingService: this.schedule.OpenService,
      dateFrom: moment(this.schedule.StartDate),
      dateTo: moment(this.schedule.EndDate),
      morningFrom: this.schedule.OpenTimeMorning ? moment(this.schedule.OpenTimeMorning).utc().format('HH:mm') : null,
      morningTo: this.schedule.CloseTimeMorning ? moment(this.schedule.CloseTimeMorning).utc().format('HH:mm') : null,
      afternoonFrom: this.schedule.OpenTimeAfternoon ? moment(this.schedule.OpenTimeAfternoon).utc().format('HH:mm') : null,
      afternoonTo: this.schedule.CloseTimeAfternoon ? moment(this.schedule.CloseTimeAfternoon).utc().format('HH:mm') : null,
      monday: this.schedule.Mon,
      tuesday: this.schedule.Tue,
      wednesday: this.schedule.Wed,
      thursday: this.schedule.Thu,
      friday: this.schedule.Fri,
      saturday: this.schedule.Sat,
      sunday: this.schedule.Sun,
      timeZone: this.schedule.TimeZone
    });
    if (this.schedule.OpenTimeAfternoon && this.schedule.CloseTimeAfternoon) {
      this.showAfternoon();
    }
  }

  public updateSchedule() {
    if (this.basicDataForm.get('allday').value) {
      this.basicDataForm.patchValue({
        morningFrom: '00:01',
        morningTo: '23:59',
        afternoonFrom: null,
        afternoonTo: null
      });
    }
    const validation = this.validateForm();
    if (validation === true) {
      const dialogRef = this.dialog.open(UpdateScheduleConfirmationDialogComponent);
      dialogRef.afterClosed().subscribe(action => {
        if (action) {
          const internalId = this.activatedRoute.snapshot.params['scheduleid'];
          const relatedEntityInternalId = this.activatedRoute.snapshot.params['deskid'];
          const morningFrom = moment(this.basicDataForm.get('morningFrom').value, 'hh:mm').hour() * 3600000 + moment(this.basicDataForm.get('morningFrom').value, 'hh:mm').minutes() * 60000;
          const morningTo =  moment(this.basicDataForm.get('morningTo').value, 'hh:mm').hour() * 3600000 + moment(this.basicDataForm.get('morningTo').value, 'hh:mm').minutes() * 60000;
          const afternoonFrom = moment(this.basicDataForm.get('afternoonFrom').value, 'hh:mm').hour() * 3600000 + moment(this.basicDataForm.get('afternoonFrom').value, 'hh:mm').minutes() * 60000;
          const afternoonTo = moment(this.basicDataForm.get('afternoonTo').value, 'hh:mm').hour() * 3600000 + moment(this.basicDataForm.get('afternoonTo').value, 'hh:mm').minutes() * 60000;
          this.updateDeskScheduleSubscription = this.desksTurnsService.updateDeskSchedule(internalId, relatedEntityInternalId, this.basicDataForm.get('monday').value, this.basicDataForm.get('tuesday').value, this.basicDataForm.get('wednesday').value, this.basicDataForm.get('thursday').value, this.basicDataForm.get('friday').value, this.basicDataForm.get('saturday').value, this.basicDataForm.get('sunday').value, morningFrom, morningTo, afternoonFrom, afternoonTo, this.basicDataForm.get('dateFrom').value.valueOf(), this.basicDataForm.get('dateTo').value.valueOf(), this.basicDataForm.get('openingService').value, this.basicDataForm.get('name').value,  this.basicDataForm.get('timeZone').value).subscribe(
            (res) => {
              this.snackbarService.open('schedule-page.snackbar messages.update schedule success', 'success');
              this.router.navigate(['../../'], {relativeTo: this.activatedRoute.parent});
            },
            (error) => {
              this.snackbarService.open(error['error']['message'], 'error');
            }
          );
        }
      });
    } else {
      this.snackbarService.open(validation, 'error');
    }
  }

  public validateForm() {
    if (!this.basicDataForm.get('name').valid) {
      return 'schedule-page.snackbar messages.name required';
    } else if (!this.basicDataForm.get('dateFrom').valid) {
      return 'schedule-page.snackbar messages.dateFrom required';
    } else if (!this.basicDataForm.get('dateTo').valid) {
      return 'schedule-page.snackbar messages.dateTo required';
    } else if (!this.basicDataForm.get('allday').value && !(this.basicDataForm.get('morningFrom').value && this.basicDataForm.get('morningTo').value) && !(this.basicDataForm.get('afternoonFrom').value && this.basicDataForm.get('afternoonTo').value)) {
      return 'schedule-page.snackbar messages.at least one interval';
    } else if (moment(this.basicDataForm.get('morningFrom').value, 'hh:mm').hour() * 3600000 + moment(this.basicDataForm.get('morningFrom').value, 'hh:mm').minutes() * 60000 > moment(this.basicDataForm.get('morningTo').value, 'hh:mm').hour() * 3600000 + moment(this.basicDataForm.get('morningTo').value, 'hh:mm').minutes() * 60000) {
      return 'schedule-page.snackbar messages.from hour greater than to hour';
    } else if (this.showingAfternoon && (moment(this.basicDataForm.get('afternoonFrom').value, 'hh:mm').hour() * 3600000 + moment(this.basicDataForm.get('afternoonFrom').value, 'hh:mm').minutes() * 60000 > moment(this.basicDataForm.get('afternoonTo').value, 'hh:mm').hour() * 3600000 + moment(this.basicDataForm.get('afternoonTo').value, 'hh:mm').minutes() * 60000)) {
      return 'schedule-page.snackbar messages.from hour greater than to hour';
    } else {
      return true;
    }
  }

  public alldayChanged() {
    if (this.basicDataForm.get('allday').value) {
      this.basicDataForm.patchValue({
        morningFrom: '00:01',
        morningTo: '23:59',
        afternoonFrom: null,
        afternoonTo: null
      });
    } else {
      this.basicDataForm.patchValue({
        morningFrom: null,
        morningTo: null,
        afternoonFrom: null,
        afternoonTo: null
      });
    }
  }

  public clearField(fieldName) {
    this.basicDataForm.patchValue({
      [fieldName]: null
    });
  }

  public showAfternoon() {
    this.showingAfternoon = !this.showingAfternoon;
  }

  public setPreselected(op1, op2) {
    if (op1 && op2) {
      return op1 === op2;
    }
  }

  ngOnDestroy() {
    if (this.updateDeskScheduleSubscription) { this.updateDeskScheduleSubscription.unsubscribe(); }
  }
}
